import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
} from "@material-ui/core";
import {
  ValidatorForm,
} from "react-material-ui-form-validator";

import { STEPPER_INTEGRACION, TIPO_SOLICITUD_INTEGRACION } from "../../data/constants";
import { 
  postSolicitudDiscapacidad, 
  setActiveStepDiscapacidad, 
} from "../../../../actions/discapacidad/discapacidadActions";
import { IntegracionComplementoTerapia } from "./IntegracionComplementoTerapia";
import { IntegracionComplementoTransporte } from "./IntegracionComplementoTransporte";
import { startAlerta } from "../../../../actions/ui/alertas";

export const IntegracionComplementoOrdenElementos = (props) => {
  const dispatch = useDispatch();

  const {
    tiposTransportes,
    solicitudSeleccionada = {},
  } = useSelector((state) => state.discapacidad);

  const [haveChangeValues, setHaveChangeValues] = useState(false);

  const disabled = props.disabled;

  const onSubmitHandler = () => {
    if((solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO ||
      solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL) &&
      (!solicitudSeleccionada?.integracionTerapia?.lunes &&
        !solicitudSeleccionada?.integracionTerapia?.martes &&
        !solicitudSeleccionada?.integracionTerapia?.miercoles &&
        !solicitudSeleccionada?.integracionTerapia?.jueves &&
        !solicitudSeleccionada?.integracionTerapia?.viernes &&
        !solicitudSeleccionada?.integracionTerapia?.sabado)){
      dispatch( startAlerta("Debe seleccionar al menos un día de la semana para la Terapia.", "error") );
    } else if(solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TRANSPORTE && 
      tiposTransportes.find(s => s.idTipoTransporte === solicitudSeleccionada?.integracionTransporte?.idTipoTransporte)?.requiereDias &&
      (!solicitudSeleccionada?.integracionTransporte?.lunes &&
        !solicitudSeleccionada?.integracionTransporte?.martes &&
        !solicitudSeleccionada?.integracionTransporte?.miercoles &&
        !solicitudSeleccionada?.integracionTransporte?.jueves &&
        !solicitudSeleccionada?.integracionTransporte?.viernes &&
        !solicitudSeleccionada?.integracionTransporte?.sabado)){
      dispatch( startAlerta("Debe seleccionar al menos un día de la semana para el Tipo de Transporte Seleccionado.", "error") );
    } else if(!haveChangeValues) {
      dispatch(setActiveStepDiscapacidad(STEPPER_INTEGRACION.DIAGNOSTICO_DOCUMENTACION));
    } else {
      dispatch(postSolicitudDiscapacidad(
        {...solicitudSeleccionada, datosComplemento: true}, 
        !props.gestion&& STEPPER_INTEGRACION.DIAGNOSTICO_DOCUMENTACION
        )
      );
    }
  };

  return (
    <ValidatorForm onSubmit={onSubmitHandler} style={{ margin: "1rem 3rem" }}>
      {solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TRANSPORTE &&
        <IntegracionComplementoTransporte setHaveChangeValues={setHaveChangeValues} disabled={disabled} />
      }
      {(solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_MODULO ||
        solicitudSeleccionada?.idTipoSolicitud === TIPO_SOLICITUD_INTEGRACION.TERAPIA_INDIVIDUAL) &&
        <IntegracionComplementoTerapia setHaveChangeValues={setHaveChangeValues} disabled={disabled} />
      }        
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        {!props.gestion &&
          <Button
            variant="contained"
            color="secondary"
            style={{ marginRight: "15rem" }}
            onClick={() => {
              dispatch(setActiveStepDiscapacidad(STEPPER_INTEGRACION.DETALLES_ORDEN));
            }}
          >
            Anterior
          </Button>
        }
        <Button type="submit"
          color="primary" 
          variant="contained"
          disabled={(props.gestion && !haveChangeValues) || props.disabled}
        >
          {props.gestion ? 'Guardar Cambios' : 'Siguiente'}
        </Button>
      </div>
    </ValidatorForm>
  );
};
